import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface FootPhotosEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: string | null;
}

export function FootPhotosEntryValue({
    value: _value,
    inputLabel,
    size,
    className,
    ...props
}: FootPhotosEntryValueProps) {
    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <p className={cn(size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-base")}>FOOT PHOTOS</p>
        </BaseEntryValue>
    );
}
